import { useMutation } from "react-query";
import { voidedAddInvoice } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useVoidedAddInvoice = () => {
  return useMutation(voidedAddInvoice);
};
